(function(){
"use strict";

angular.module("swapick")
.factory('Categories', Categories);

function Categories(DataService, $q){
  
  this.categories = null;
  this.data = {};

  this.loadCategories = () => {
    return DataService.categories.get()
    .then(categories => {
      return this.setupCategories(categories);
    })
  }


  this.getCategories = () => {
    const cat = this.categories ? this.setupCategories(this.categories) : this.loadCategories()
    return $q.when(cat);
  }


  this.setupCategories = categories => {
    
    this.categories = categories;
    
    const mondi = _.uniqBy(_.map(categories, item =>{
      return item.mondo;
    }), 'id')
    this.data.mondi = mondi;
    this.data.mondiById = _.groupBy(mondi, 'id');
    
    const ids = _.map(categories,item=>{
      return { mondo : item.mondo.id, categoria : item.id}
    })
    const idsByMondo = _.groupBy(ids, 'mondo');
    let categoriesIdByMondoId = {};
    _.each(idsByMondo, (v,k)=>{
      categoriesIdByMondoId[k] = _.map(v, 'categoria')
    })
    this.data.categoriesIdByMondoId = categoriesIdByMondoId;


    this.data.categoriesByMondo = _.groupBy(categories, item => {
      return item.mondo.id;
    });

    this.data.categoriesById = _.groupBy(categories, 'id');

    //console.info("categories setup", categories);

    return categories;

  };

  


  return this;    
}



})();


// WEBPACK FOOTER //
// ./src/services/categories-service.js